export default __webpack_public_path__ + "static/media/what-01.5880f40f.png";